import { render, staticRenderFns } from "./RemindWaitDate.vue?vue&type=template&id=d31f9fbe&scoped=true"
import script from "./RemindWaitDate.vue?vue&type=script&lang=js"
export * from "./RemindWaitDate.vue?vue&type=script&lang=js"
import style0 from "./RemindWaitDate.vue?vue&type=style&index=0&id=d31f9fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31f9fbe",
  null
  
)

export default component.exports